module.exports = __webpack_public_path__ + "static/media/seedling.3f6e822d.svg";